export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';

export const loginAction = () => ({
  type: LOGIN,
});

export const logoutAction = () => ({
  type: LOGOUT,
});
